<script setup lang="ts">
// Carteira do Minha Conta V2 (ENG-362). Rota sem frame no Figma: moldura no
// padrão V2 (Shell + tokens v2-*) preservando os cards funcionais antigos de
// saldo — fluxos de depósito/saque/bônus/cashback são código sensível e ficam
// embutidos (UserWalletRealWallet/BonusWallet/CashbackWallet), não refeitos.
// O par Depositar/Sacar do V2 (UserV2WalletActionButtons) entra no slot
// #actions do RealWallet.vue, no mesmo lugar do par antigo — não do lado.
const { userCurrency, userCountry, userId } = useUserData();
const { userCanOnlyWithdraw } = useUserLimits();
</script>

<template>
  <div
    class="flex flex-col gap-[12px] md:grid md:grid-cols-2 md:items-start md:gap-[16px]"
  >
    <!-- span-2 também: largura cheia igual ao Bônus, senão a borda direita
         dos dois cards não bate e os ícones de canto ficam desalinhados. -->
    <UserWalletRealWallet
      class="md:col-span-2"
      :user-country="userCountry"
      :user-currency="userCurrency"
      :user-id="userId"
    >
      <template #actions>
        <UserV2WalletActionButtons size="compact" />
      </template>
    </UserWalletRealWallet>

    <!-- span-2: o card do bônus tem 2 colunas internas (valor + rollover) e
         não cabe espremido na metade do grid — ocupa a linha inteira,
         abaixo do Carteira, em vez de lado a lado. -->
    <UserWalletBonusWallet
      v-if="!userCanOnlyWithdraw"
      class="md:col-span-2"
      :user-id="userId"
      variant="v2"
    />

    <UserWalletCashbackWallet
      v-if="!userCanOnlyWithdraw"
      :user-id="userId"
    />
  </div>

  <NuxtLink
    v-if="!userCanOnlyWithdraw"
    class="border-solid flex w-full items-center justify-between gap-[8px] rounded-[12px] border border-v2-default/40 bg-v2-default/40 px-[12px] py-[10px]"
    :to="localeLink('/user/wallet/transactions')"
  >
    <span class="text-[12px] leading-[16px] text-v2-foreground">
      Procurando o histórico de transações?
      <strong class="font-semibold">Toque aqui para acessar.</strong>
    </span>
    <UserV2Icon
      class="shrink-0 text-v2-default-700"
      name="chevron-right"
    />
  </NuxtLink>
</template>
